import React, { MouseEvent } from 'react';
import { Emoji } from 'emoji-mart';
import { css } from '@emotion/react';

interface EntryProps {
  emoji: string;
  onEmojiSelect(emoji: string): void;
  index: number;
  onEmojiFocus(index: number): void;
  isFocused: boolean;
  id: string;
}

const Entry: React.FC<EntryProps> = ({
  emoji,
  onEmojiSelect,
  index,
  onEmojiFocus,
  isFocused,
  id,
}) => {
  const mouseDown = React.useRef(false);
  const entryRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (isFocused) {
      if ('scrollIntoViewIfNeeded' in document.body) {
        entryRef &&
          (entryRef?.current as { scrollIntoViewIfNeeded?: any }).scrollIntoViewIfNeeded(false);
      } else {
        entryRef && entryRef?.current?.scrollIntoView(false);
      }
    }
  }, [isFocused]);

  const onMouseUp = (): void => {
    if (mouseDown) {
      mouseDown.current = false;
      onEmojiSelect(emoji);
    }
  };

  const onMouseDown = (event: MouseEvent): void => {
    // Note: important to avoid a content edit change
    event.preventDefault();
    mouseDown.current = true;
  };

  const onMouseEnter = (): void => {
    onEmojiFocus(index);
  };

  return (
    <div
      ref={(e) => {
        entryRef.current = e;
      }}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseEnter={onMouseEnter}
      role='option'
      id={id}
      aria-selected={isFocused ? 'true' : undefined}
      className='flex items-center py-1/3e px-3/4e'
      css={css`
        ${isFocused && `background-color: #e6f3ff;`}
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          background-color: #e6f3ff;
        }
        .emoji-mart-emoji {
          margin-top: 0.5rem;
        }
      `}
    >
      <Emoji emoji={emoji} size={20} />
      <span
        className='block ml-1/2e'
        css={css`
          width: 15rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
      >
        :{emoji}:
      </span>
    </div>
  );
};

export default Entry;
